// Page
import PasswordReset from "../components/Registration/PasswordReset/index.js";

const PasswordResetPage = () => {
  	return (
    	<PasswordReset/>
  	)
}

export default PasswordResetPage;